import React, {useState} from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"

import clsx from 'clsx'
import styles from './BpmFilter.module.scss'
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Slider from '@mui/material/Slider';
import Input from '@mui/material/Input';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import FormControlLabel from '@mui/material/FormControlLabel';

import StyledPopup from '../../components/StyledPopup'

const BpmFilter = observer(({className, classes, model}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClose = () => {
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl)

  const filter = useLocalObservable(() => ({
    minBpm: 40,
    maxBpm: 200,
    doubled: 1,
    min: 40,
    max: 200,
    changed: false,
    get isDefault() {
      return this.doubled == 1 && this.minBpm == 40 && this.maxBpm == 200
    },
    setDoubled(e) {
      this.doubled = e.target.checked ? 1 : 0
      this.changed = true
    },
    setRangeValue(e, values) {
      this.minBpm = values[0]
      this.maxBpm = values[1]
      this.syncBpm()
    },
    syncBpm() {
      this.min = this.minBpm
      this.max = this.maxBpm
      this.changed = true
    },
    setMin(e) {
      this.min = e.target.value.replace(/[^\d]/g,"")
    },
    setMax(e) {
      this.max = e.target.value.replace(/[^\d]/g,"")
    },
    applyRange() {
      let [m, x] = [this.min, this.max]
      if (m > x) {
        [m, x] = [x, m]
      }
      this.minBpm = m < 40 ? 40 : m
      this.maxBpm = x > 200 ? 200 : x
      this.syncBpm()
    },
    reset() {
      this.minBpm = 40
      this.maxBpm = 200
      this.doubled = 1
      this.syncBpm()
      this.update()
    },
    update() {
      this.changed = false
    },
    apply() {
      if (this.changed) {
        this.update()
      } else {
        this.reset()
      }
      handleClose()
      model.setBpm({minBpm: this.minBpm, maxBpm: this.maxBpm, doubled: this.doubled})
    },
    syncData(minBpm, maxBpm, doubled) {
      this.minBpm = minBpm;
      this.maxBpm = maxBpm
      this.doubled = doubled
      this.syncBpm()
      this.changed = false
    },
    toOpen(e) {
      setAnchorEl(e.currentTarget);
      const original = model.bpm
      this.syncData(original.minBpm, original.maxBpm, original.doubled)
    },
    onKeyUp(e) {
      if(e.keyCode === 13) {
        this.applyRange()
      }
    }
  }))

  const isDefaultBpm = model.isDefaultBpm

  const text = isDefaultBpm ? "Any BPM" : (model.bpm.doubled == 1 ? '*' : '') + `${model.bpm.minBpm} - ${model.bpm.maxBpm} BPM`

  return <div className={clsx(styles['root'], className)}>
    {/* <Button aria-describedby={id} variant="outlined" className={classes.button} onClick={handleClick}>
      Any BPM <ArrowDropDownIcon />
    </Button> */}
    <StyledPopup value={text} open={open} handleClick={filter.toOpen} className={clsx(classes.button, isDefaultBpm ? null : styles.active)} />
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      classes={{paper: styles['popover-paper'], root: styles['popover-root']}}
    >
      <div>
        <FormControlLabel 
          classes={{label: styles['include-label']}}
          control={
            <Checkbox 
              size="small" 
              name="checkedH2" 
              color="primary" 
              checked={filter.doubled == 1}
              onChange={filter.setDoubled}
              classes={{root: styles['include-checkbox'], checked: styles['include-checked']}}
              checkedIcon={<CheckBoxOutlinedIcon />} />
          }
          label="Include halved/doubled bpm" 
        />
      </div>
      <div className={styles['range']}>
        <div className={styles['left']}><Input className={styles['input-root']} value={filter.min} onChange={filter.setMin} onBlur={filter.applyRange} onKeyUp={filter.onKeyUp} /></div>
        <div className={styles['slider']}>
        <Slider
          min={40}
          max={200}
          value={[filter.minBpm, filter.maxBpm]}
          onChange={filter.setRangeValue}
          classes={{
            rail: styles['rail'],
            track: styles['track'],
            thumb: styles['thumb']
          }}
          valueLabelDisplay="off"
          aria-labelledby="range-slider"
        />
        </div>
        <div className={styles['right']}><Input className={styles['input-root']} value={filter.max} onChange={filter.setMax} onBlur={filter.applyRange} onKeyUp={filter.onKeyUp} /></div>
      </div>
      <div >
        <Button variant="contained" disableElevation className={styles['reset']} onClick={filter.apply}>
        {filter.changed || filter.isDefault ? 'Update' : 'Reset'}
        </Button>
      </div>
    </Popover>
  </div>
})

export default BpmFilter